var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[[(!_vm.loadingConfig && !_vm.loadingAuth)?_c('router-view',{on:{"authenticated":_vm.setAuthenticated}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }